module.exports = "./img/a276b6ead7d5ff453fb5ea9dff89e919.jpg";